<template>
  <div class="text-right">
    <h4>{{ $t('language') }}</h4>
    <ul class="list-unstyled">
      <li v-for="locale in locales" :key="locale.locale">
        <span v-if="$i18n.locale == locale.locale">{{ locale.name }}</span>
        <a v-else :href="'?lang='+locale.locale" @click="warnIfLoggedIn(locale.name, $event)">{{ locale.name }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
  const allLocales = [
    {locale: 'en', name: 'English'},
    {locale: 'es', name: 'Español'},
    {locale: 'ko', name: '한국어'},
    {locale: 'ru', name: 'русский'},
    {locale: 'zh', name: '简体中文'},
    {locale: 'vi', name: 'Tiếng Việt'},
    {locale: 'pt', name: 'Português'}
  ];

  export default {
    name: "LocaleSelect",
    data() {
      return {
        locales: allLocales.filter(l => this.$store.state.locales.includes(l.locale))
      }
    },
    methods: {
      warnIfLoggedIn(lang, e) {
        if (this.$store.getters.isLoggedIn) {
          if (!confirm(this.$t('changeLanguage', {lang}))) {
            e.preventDefault();
            return false;
          }
        }
      }
    }
  }
</script>
